import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "warning--sprite",
  "use": "warning--sprite-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"warning--sprite\">\n<path d=\"M1.33301 28.6668H30.6663L15.9997 3.3335L1.33301 28.6668ZM17.333 24.6668H14.6663V22.0002H17.333V24.6668ZM17.333 19.3335H14.6663V14.0002H17.333V19.3335Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol